import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HospitalStateService } from './services/hospitalstate.service';
import { LoginService } from './login.service';
import { UserAuthService } from './auth/userAuth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private _hospital: UserAuthService,
    private _loginService: LoginService,
    private _hospitalState: HospitalStateService
  ) {
    translate.addLangs(['en', 'fr', 'es']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr|es/) ? browserLang : 'en');
    this.loadHospitalData();
  }

  loadHospitalData() {
    const hospitalId = this._loginService.getHospitalId();
    if (!hospitalId) return;
    this._hospital.getHospital(hospitalId).subscribe(res => {
      this._hospitalState.setHospital(res.result);
    });
  }
}
